import { VictoryLegend } from "victory";

export default VictoryLegend;
